import LanguageToggle from './LanguageToggle'
import { VietradeLogo } from './VietradeLogo'
import { VietradeLogoSmall } from './VietradeLogoSmall'
import Button from './Button'

export default function Header() {
  return (
    <>
    <div className='bg-gradient-to-r from-sky-400 to-blue-500 text-white relative'>
        <div className='container mx-auto px-4 py-6 text-center'>
            <div className='flex items-center justify-center space-x-4 mb-3'>
                <VietradeLogo size="sm"/>
                <div>
                    <h1 className='text-2xl font-bold'>
                        CỤC XÚC TIẾN THƯƠNG MẠI VIỆT NAM
                    </h1>
                    <p className='text-sm text-sky-100'>
                        Trợ lý số VietradeAI - Đồng hành cùng doanh nghiệp Việt Nam vươn ra thế giới
                    </p>
                </div>
            </div>
        </div>
        <div className='h-1 bg-gradient-to-r from-yellow-400 via-red-500 to-yellow-400'></div>
    </div>
    <div className='bg-white shadow-sm border-b'>
        <div className='container mx-auto px-4 py-2 flex justify-between items-center'>
            <VietradeLogoSmall/>
            <div className='flex items-center space-x-4'>
                <Button variant="ghost" size="sm" className="text-gray-700">
                    Giới thiệu
                </Button>
                <LanguageToggle/>
            </div>
        </div>
    </div>
    </>
    
  )
}
